var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 43,
    viewBox: "0 0 148 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.519 43H5.48148C2.46804 43 0 40.5798 0 37.625V5.375C0 2.42009 2.46804 0 5.48148 0H142.519C145.532 0 148 2.42009 148 5.375V37.625C148 40.5798 145.532 43 142.519 43Z",
    fill: "#13121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.519 0.861344C145.056 0.861344 147.122 2.88637 147.122 5.375V37.625C147.122 40.1136 145.056 42.1387 142.519 42.1387H5.48148C2.94356 42.1387 0.878407 40.1136 0.878407 37.625V5.375C0.878407 2.88637 2.94356 0.861344 5.48148 0.861344H142.519ZM142.519 0H5.48148C2.46804 0 0 2.42009 0 5.375V37.625C0 40.5798 2.46804 43 5.48148 43H142.519C145.532 43 148 40.5798 148 37.625V5.375C148 2.42009 145.532 0 142.519 0Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9816 11.0123C51.9816 11.9099 51.7076 12.6288 51.1676 13.165C50.5468 13.8005 49.7383 14.1203 48.7476 14.1203C47.8006 14.1203 46.9921 13.7952 46.3288 13.1542C45.6642 12.5039 45.3325 11.7057 45.3325 10.7502C45.3325 9.79485 45.6642 8.99666 46.3288 8.35166C46.9921 7.70531 47.8006 7.38013 48.7476 7.38013C49.2189 7.38013 49.6684 7.47553 50.0974 7.65291C50.5249 7.83163 50.873 8.0735 51.1251 8.37181L50.5523 8.93888C50.1124 8.42961 49.5135 8.17833 48.7476 8.17833C48.0569 8.17833 47.458 8.41481 46.9496 8.89185C46.4467 9.37022 46.1946 9.98969 46.1946 10.7502C46.1946 11.5108 46.4467 12.1357 46.9496 12.6141C47.458 13.0857 48.0569 13.3275 48.7476 13.3275C49.4807 13.3275 50.0974 13.0857 50.5838 12.6087C50.9045 12.2928 51.0867 11.8575 51.1347 11.3012H48.7476V10.5245H51.9322C51.9706 10.6925 51.9816 10.855 51.9816 11.0123Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0343 8.31857H54.0427V10.3611H56.7397V11.1378H54.0427V13.1803H57.0343V13.9718H53.1959V7.5271H57.0343V8.31857Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6032 13.9718H59.7564V8.31857H57.9214V7.5271H62.4395V8.31857H60.6032V13.9718Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7094 13.9718V7.5271H66.5549V13.9718H65.7094Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3015 13.9718H69.4614V8.31857H67.6197V7.5271H72.1432V8.31857H70.3015V13.9718Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6975 13.1435C80.0493 13.7952 79.2462 14.1203 78.2884 14.1203C77.325 14.1203 76.5219 13.7952 75.8737 13.1435C75.2269 12.4931 74.905 11.6949 74.905 10.7502C74.905 9.8056 75.2269 9.00741 75.8737 8.35703C76.5219 7.70531 77.325 7.38013 78.2884 7.38013C79.2407 7.38013 80.0438 7.70531 80.692 8.36241C81.3443 9.01816 81.6663 9.81097 81.6663 10.7502C81.6663 11.6949 81.3443 12.4931 80.6975 13.1435ZM76.5 12.6033C76.9879 13.0857 77.5812 13.3275 78.2884 13.3275C78.99 13.3275 79.5888 13.0857 80.0712 12.6033C80.5577 12.1208 80.8044 11.5014 80.8044 10.7502C80.8044 9.9991 80.5577 9.37963 80.0712 8.89722C79.5888 8.41481 78.99 8.17294 78.2884 8.17294C77.5812 8.17294 76.9879 8.41481 76.5 8.89722C76.0136 9.37963 75.7669 9.9991 75.7669 10.7502C75.7669 11.5014 76.0136 12.1208 76.5 12.6033Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.852 13.9718V7.5271H83.8797L87.0755 12.5393H87.1125L87.0755 11.3004V7.5271H87.921V13.9718H87.0385L83.6921 8.71229H83.6551L83.6921 9.9566V13.9718H82.852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6973 23.3846C72.1224 23.3846 70.0189 25.3062 70.0189 27.9574C70.0189 30.5871 72.1224 32.5289 74.6973 32.5289C77.2778 32.5289 79.3813 30.5871 79.3813 27.9574C79.3813 25.3062 77.2778 23.3846 74.6973 23.3846ZM74.6973 30.7283C73.2844 30.7283 72.069 29.5847 72.069 27.9574C72.069 26.3086 73.2844 25.1852 74.6973 25.1852C76.1102 25.1852 77.3312 26.3086 77.3312 27.9574C77.3312 29.5847 76.1102 30.7283 74.6973 30.7283ZM64.4895 23.3846C61.909 23.3846 59.811 25.3062 59.811 27.9574C59.811 30.5871 61.909 32.5289 64.4895 32.5289C67.0684 32.5289 69.1679 30.5871 69.1679 27.9574C69.1679 25.3062 67.0684 23.3846 64.4895 23.3846ZM64.4895 30.7283C63.0752 30.7283 61.8556 29.5847 61.8556 27.9574C61.8556 26.3086 63.0752 25.1852 64.4895 25.1852C65.9022 25.1852 67.1178 26.3086 67.1178 27.9574C67.1178 29.5847 65.9022 30.7283 64.4895 30.7283ZM52.3424 24.7862V26.7293H57.0744C56.936 27.815 56.566 28.6132 55.9987 29.1695C55.308 29.8414 54.2322 30.5871 52.3424 30.5871C49.4305 30.5871 47.1501 28.2826 47.1501 25.4271C47.1501 22.5717 49.4305 20.2671 52.3424 20.2671C53.917 20.2671 55.0626 20.8705 55.9082 21.6526L57.3046 20.2832C56.122 19.176 54.5488 18.3254 52.3424 18.3254C48.3492 18.3254 44.9932 21.5114 44.9932 25.4271C44.9932 29.3428 48.3492 32.5289 52.3424 32.5289C54.5008 32.5289 56.122 31.8355 57.3964 30.5348C58.7024 29.2541 59.1094 27.4535 59.1094 25.9995C59.1094 25.548 59.071 25.1329 59.0024 24.7862H52.3424ZM102.013 26.2925C101.628 25.2699 100.44 23.3846 98.0196 23.3846C95.6215 23.3846 93.6249 25.2377 93.6249 27.9574C93.6249 30.5186 95.6009 32.5289 98.2499 32.5289C100.392 32.5289 101.628 31.2482 102.136 30.5025L100.547 29.4637C100.016 30.2243 99.2941 30.7283 98.2499 30.7283C97.2125 30.7283 96.4684 30.2619 95.9915 29.3428L102.228 26.8126L102.013 26.2925ZM95.6544 27.815C95.6009 26.052 97.0508 25.149 98.0896 25.149C98.9036 25.149 99.5942 25.548 99.8245 26.1192L95.6544 27.815ZM90.5854 32.2507H92.6354V18.8132H90.5854V32.2507ZM87.228 24.4032H87.1594C86.699 23.8684 85.8207 23.3846 84.7079 23.3846C82.3728 23.3846 80.2378 25.3949 80.2378 27.9722C80.2378 30.5348 82.3728 32.5289 84.7079 32.5289C85.8207 32.5289 86.699 32.041 87.1594 31.4901H87.228V32.1459C87.228 33.8941 86.2756 34.8334 84.7394 34.8334C83.4869 34.8334 82.7099 33.9465 82.3892 33.2008L80.6064 33.9304C81.1203 35.1424 82.481 36.634 84.7394 36.634C87.143 36.634 89.1712 35.2472 89.1712 31.8731V23.6628H87.228V24.4032ZM84.8832 30.7283C83.4705 30.7283 82.2878 29.5685 82.2878 27.9722C82.2878 26.3611 83.4705 25.1852 84.8832 25.1852C86.2756 25.1852 87.3733 26.3611 87.3733 27.9722C87.3733 29.5685 86.2756 30.7283 84.8832 30.7283ZM111.611 18.8132H106.708V32.2507H108.752V27.1593H111.611C113.882 27.1593 116.108 25.548 116.108 22.9856C116.108 20.4244 113.876 18.8132 111.611 18.8132ZM111.665 25.29H108.752V20.6824H111.665C113.191 20.6824 114.063 21.9253 114.063 22.9856C114.063 24.0256 113.191 25.29 111.665 25.29ZM124.303 23.3591C122.826 23.3591 121.29 23.9988 120.659 25.4164L122.472 26.1622C122.864 25.4164 123.581 25.1745 124.34 25.1745C125.401 25.1745 126.477 25.7994 126.493 26.9025V27.0437C126.123 26.8341 125.331 26.5236 124.356 26.5236C122.402 26.5236 120.412 27.5785 120.412 29.547C120.412 31.3477 122.012 32.5074 123.812 32.5074C125.188 32.5074 125.947 31.8986 126.423 31.1905H126.493V32.2292H128.468V27.0745C128.468 24.6921 126.654 23.3591 124.303 23.3591ZM124.056 30.7229C123.388 30.7229 122.456 30.3977 122.456 29.5847C122.456 28.5446 123.619 28.1456 124.623 28.1456C125.524 28.1456 125.947 28.3404 126.493 28.5971C126.333 29.8414 125.24 30.7229 124.056 30.7229ZM135.662 23.6534L133.313 29.4786H133.242L130.813 23.6534H128.608L132.258 31.7938L130.176 36.3236H132.312L137.937 23.6534H135.662ZM117.232 32.2507H119.283V18.8132H117.232V32.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4384 8.10357C11.1163 8.43413 10.9299 8.94879 10.9299 9.61529V33.389C10.9299 34.0555 11.1163 34.5701 11.4384 34.9006L11.5179 34.9732L25.1037 21.6566V21.3422L11.5179 8.02563L11.4384 8.10357Z",
    fill: "url(#paint0_linear_10_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6301 26.0981L25.1066 21.6571V21.3426L29.6356 16.9015L29.737 16.9593L35.1006 19.9518C36.6314 20.8011 36.6314 22.1986 35.1006 23.0532L29.737 26.0404L29.6301 26.0981Z",
    fill: "url(#paint1_linear_10_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7368 26.0413L25.1064 21.5007L11.441 34.902C11.9494 35.4261 12.7785 35.4892 13.7213 34.9651L29.7368 26.0413Z",
    fill: "url(#paint2_linear_10_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7368 16.9595L13.7213 8.03557C12.7785 7.51688 11.9494 7.58004 11.441 8.1041L25.1064 21.4999L29.7368 16.9595Z",
    fill: "url(#paint3_linear_10_10)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_10",
    x1: 23.8974,
    y1: 33.6365,
    x2: 5.85981,
    y2: 15.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_10",
    x1: 37.0938,
    y1: 21.4983,
    x2: 10.5669,
    y2: 21.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_10",
    x1: 27.2189,
    y1: 19.0324,
    x2: 2.75844,
    y2: -5.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_10",
    x1: 8.00116,
    y1: 42.8105,
    x2: 18.9239,
    y2: 31.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownPlaystore);
export default __webpack_public_path__ + "static/media/down-playstore.0d2b40f1e560764a1ba6d75c541fc306.svg";
export { ForwardRef as ReactComponent };